import axios from "axios";
import Swal from "sweetalert2";
import store from '../state/store';

export default class Api {
    constructor() {
        // En développement local, utiliser le proxy Vue en chemin relatif '/api'
        // Pour repasser sur l'API distante en prod, vous pouvez basculer sur l'URL absolue.
       // const isDev = process.env.NODE_ENV === 'development';
        const baseUrl =  'https://api-track.wibus.ml/api';

        this.call = axios.create({
            baseURL: baseUrl,
        });

        this.callLogin = axios.create({
            baseURL: baseUrl,
        });

        this.isRefreshing = false;
        this.refreshSubscribers = [];

        this.setupInterceptors();
    }

    async getAuthHeaders() {
        const token = store.state.jwt_token;
        if (token) {
            return {
                'Authorization': `Bearer ${token}`
            };
        }
        return {};
    }

    setupInterceptors() {
        this.call.interceptors.request.use((config) => {
            const token = store.state.jwt_token;
            if (token) {
                config.headers['Authorization'] = `Bearer ${token}`;
            }
            return config;
        });

        this.call.interceptors.response.use(
            (response) => response,
            async (error) => {
                const originalRequest = error.config;
                const status = error.response?.status;

                if (status === 401 && !originalRequest._retry) {
                    originalRequest._retry = true;

                    if (this.isRefreshing) {
                        return new Promise((resolve) => {
                            this.refreshSubscribers.push((token) => {
                                originalRequest.headers['Authorization'] = `Bearer ${token}`;
                                resolve(this.call(originalRequest));
                            });
                        });
                    }

                    this.isRefreshing = true;

                    const newTokens = await this.refreshToken();
                    this.isRefreshing = false;

                    if (newTokens?.token) {
                        this.refreshSubscribers.forEach((cb) => cb(newTokens.token));
                        this.refreshSubscribers = [];

                        originalRequest.headers['Authorization'] = `Bearer ${newTokens.token}`;
                        return this.call(originalRequest);
                    } else {
                        this.logout();
                        return Promise.reject(error);
                    }
                }

                this.toast();
                return Promise.reject(error);
            }
        );
    }
    async listing(url, fields, orderBy, sortOrder, itemPerPage, currentPage) {

        try {


            let list;
            if(fields ==null){
                list =  this.call.get(url);
            }else {
                let query = '';
                if(url.includes('?'))
                    query = url+'&orderBy=' + orderBy + '&sortOrder=' + sortOrder + '&itemsperpage=' + itemPerPage + '&page=' + currentPage;
                else
                    query = url+'?orderBy=' + orderBy + '&sortOrder=' + sortOrder + '&itemsperpage=' + itemPerPage + '&page=' + currentPage;

                fields.forEach(function (element) {
                    let tableau = null;
                    switch (element.operator) {
                        case 'eq':
                            query = query + '&filter[' + element.colonne + '][type]=' + element.operator + '&filter[' + element.colonne + '][x]=' + element.value+ '&filter[' + element.colonne + '][connector]=' + element.connector;
                            break;
                        case 'not eq':
                            query = query + '&filter[' + element.colonne + '][type]=' + element.operator + '&filter[' + element.colonne + '][x]=' + element.value+ '&filter[' + element.colonne + '][connector]=' + element.connector;
                            break;
                        case 'gt':
                            query = query + '&filter[' + element.colonne + '][type]=' + element.operator + '&filter[' + element.colonne + '][x]=' + element.value+ '&filter[' + element.colonne + '][connector]=' + element.connector;
                            break;
                        case 'gte':
                            query = query + '&filter[' + element.colonne + '][type]=' + element.operator + '&filter[' + element.colonne + '][x]=' + element.value+ '&filter[' + element.colonne + '][connector]=' + element.connector;
                            break;
                        case 'lt':
                            query = query + '&filter[' + element.colonne + '][type]=' + element.operator + '&filter[' + element.colonne + '][x]=' + element.value+ '&filter[' + element.colonne + '][connector]=' + element.connector;
                            break;
                        case 'lte':
                            query = query + '&filter[' + element.colonne + '][type]=' + element.operator + '&filter[' + element.colonne + '][x]=' + element.value+ '&filter[' + element.colonne + '][connector]=' + element.connector;
                            break;
                        case 'like':
                            query = query + '&filter[' + element.colonne + '][type]=' + element.operator + '&filter[' + element.colonne + '][x]=' + element.value+ '&filter[' + element.colonne + '][connector]=' + element.connector;
                            break;
                        case 'not like':
                            query = query + '&filter[' + element.colonne + '][type]=' + element.operator + '&filter[' + element.colonne + '][x]=' + element.value+ '&filter[' + element.colonne + '][connector]=' + element.connector;
                            break;
                        case 'is null':
                            query = query + '&filter[' + element.colonne + '][type]=' + element.operator;
                            break;
                        case 'is not null':
                            query = query + '&filter[' + element.colonne + '][type]=' + element.operator;
                            break;
                        case 'in':
                            query = query + '&filter[' + element.colonne + '][type]=' + element.operator + '&filter[' + element.colonne + '][x]=' + element.value+ '&filter[' + element.colonne + '][connector]=' + element.connector;
                            break;
                        case 'not in':
                            query = query + '&filter[' + element.colonne + '][type]=' + element.operator + '&filter[' + element.colonne + '][x]=' + element.value+ '&filter[' + element.colonne + '][connector]=' + element.connector;
                            break;
                        case 'between':
                            tableau = element.value.split('et');
                            console.log(tableau[0]);
                            query = query + '&filter[' + element.colonne + '][type]=' + element.operator + '&filter[' + element.colonne + '][x]=' + tableau[0].trim() + '&filter[' + element.colonne + '][y]=' + tableau[1].trim()+ '&filter[' + element.colonne + '][connector]=' + element.connector;
                            //console.log(query);

                            break;
                        case 'dateBetween':
                            // tableau = element.value.split('au');
                            //console.log(tableau[0]);
                            query = query + '&filter[' + element.colonne + '][type]=' + element.operator + '&filter[' + element.colonne + '][x]=' + element.x.trim() + '&filter[' + element.colonne + '][y]=' + element.y.trim()+ '&filter[' + element.colonne + '][connector]=' + element.connector;
                            //console.log(query);

                            break;


                    }
                });
                //console.log(query);
                list = await this.call.get(query, {
                    headers: {
                    }
                });
            }
            //console.log(list.data);
            return list.data;
        }catch (e) {
            this.toast();

        }
    }

    async refreshToken() {
        const refreshToken = store.state.refresh_token;
        if (!refreshToken) {
            this.logout();
            return null;
        }

        try {
            const response = await this.callLogin.post(
                `/token/refresh`,
                { refresh_token: refreshToken },
                { headers: { 'Content-Type': 'application/json' } }
            );

            if (response.status === 200) {
                const data = response.data;
                localStorage.setItem('jwt_token', data.token);
                await store.dispatch("setJwtToken", data.token);
                if (data.refresh_token) {
                    localStorage.setItem('refresh_token', data.refreshToken);
                    await store.dispatch("setRefreshToken", data.refreshToken);
                }
                return data;
            } else {
                this.logout();
                return null;
            }
        } catch (e) {
            this.logout();
            return null;
        }
    }

    async login(credentials) {
        try {
            const response = await this.callLogin.post("login_check", credentials);
            const data = response.data;

            if (data.token) {
                localStorage.setItem('jwt_token', data.token);
                await store.dispatch("setJwtToken", data.token);

                localStorage.setItem('refresh_token', data.refresh_token);
                await store.dispatch("setRefreshToken", data.refresh_token);

                return data;
            }
            return false;
        } catch (e) {
            return false;
        }
    }

    async post(url, data) {
        try {
            const response = await this.call.post(url, data, {
                headers: {
                    // Utilisation de application/json standard pour éviter les rejets CORS preflight
                    "Content-Type": "application/json"
                }
            });
            if (response.status === 201 || response.status === 200) {
                return response.data;
            } else {
                this.toast();
            }
        } catch (e) {
            this.toast();
        }
    }

    async get(url) {
        try {
            const list = await this.call.get(url);
            return list.data;
        } catch (e) {
            this.toast();
        }
    }

    toast() {
        // Correction de la syntaxe SweetAlert2 pour éviter l'erreur "Unknown parameter confirmButtonClass"
        Swal.fire({
            title: "Oops...",
            text: "Une erreur s'est produite !",
            icon: "error",
            customClass: {
                confirmButton: "btn btn-primary w-xs mt-2"
            },
            buttonsStyling: false,
            showCloseButton: true,
        });
    }

    logout() {
        localStorage.removeItem('jwt_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('currentUser');
        Swal.fire({
            title: "Session expirée",
            text: "Veuillez vous reconnecter.",
            icon: "error",
        }).then(() => {
            window.location.href = '/login';
        });
    }
}